import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config';
import type {
  SetCompanyWebhookEnabledParams,
  SetCompanyWebhookEnabledResponse,
} from '../../../../types/webhook';

/**
 * 運営スタッフ専用: 企業の webhook_enabled を切り替える（spec §7.2）。
 */
interface SetCompanyWebhookEnabledRawResponse {
  success: boolean;
  before: boolean;
  after: boolean;
}

export const setCompanyWebhookEnabled = async (
  params: SetCompanyWebhookEnabledParams,
): Promise<SetCompanyWebhookEnabledResponse> => {
  const callable = httpsCallable<
    SetCompanyWebhookEnabledParams,
    SetCompanyWebhookEnabledRawResponse
  >(functions, 'setCompanyWebhookEnabled');
  const result = await callable(params);
  return {
    before: result.data.before,
    after: result.data.after,
  };
};
